import type { LintDiagnostic } from '../../types/lint.js';
import type { SchemaValidationResult } from '../../schemas/validators.js';

export function runSchemaRules(file: string, result: SchemaValidationResult<unknown>): LintDiagnostic[] {
  if (result.valid) return [];

  return result.errors.map((e) => ({
    file,
    code: `${file === 'CHARTER.md' ? 'CHARTER' : 'TOOLS'}.SCHEMA.INVALID`,
    path: e.path,
    severity: 'error' as const,
    message: `Schema validation failed at ${e.path}: ${e.message}`,
  }));
}
